<template>
    <div style="padding-top: 30px">
        <div>
            <p class="open-sans-30pt">
                A ste vedeli, da ...
            </p>
        </div>
        <div class="grid-container">
            <div>
                <div class="levi-pomik-slika">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-globe-americas.png"
                         class="velikost-slike">
                </div>
                <div>
                    <div class="pomik-besedila-spletne-predstavitve">
                        <p class="navadno-besedilo">
                            <b class="postavitev-naslova-spletna-predstavitev">
                                je bilo januarja 2020 kar 1,74 miljard spletnih strani?
                            </b>
                        </p>
                        <p class="postavitev-besedila-spletna-predstavitev navadno-besedilo">
                            Čisto prva spletna stran pa je bila objavljena 6. avgusta 1991.
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <div class="levi-pomik-slika">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-users.png"
                         class="velikost-slike">
                </div>
                <div>
                    <div class="pomik-besedila-spletne-predstavitve">
                        <p class="navadno-besedilo">
                            <b class="postavitev-naslova-spletna-predstavitev">
                                je največ uporabnikov interneta na Falklandskih otokih (99,3 %), takoj
                                za njimi pa so Islandci (99 %)?
                            </b>
                        </p>
                        <p class="postavitev-besedila-spletna-predstavitev navadno-besedilo">
                            Za visok procent sta najverjetneje krivi nizki številki prebivalcev držav.
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <div class="levi-pomik-slika">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-awesome-google.png"
                         class="velikost-slike">
                </div>
                <div>
                    <div class="pomik-besedila-spletne-predstavitve">
                        <p class="navadno-besedilo">
                            <b class="postavitev-naslova-spletna-predstavitev">
                                Google vsak dan opravi vsaj 7 miljard iskanj?
                            </b>
                        </p>
                        <p class="postavitev-besedila-spletna-predstavitev navadno-besedilo">
                            Nekateri pravijo, da bi jih lahko bilo tudi do 10 miljard. Še bolj
                            fascinantno je to, da 15% dnevnih iskanj nikoli prej niso bila opravljena.
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <div class="levi-pomik-slika">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev/Icon-metro-wifi-connect.png"
                         class="velikost-slike">
                </div>
                <div>
                    <div class="pomik-besedila-spletne-predstavitve">
                        <p class="navadno-besedilo">
                            <b class="postavitev-naslova-spletna-predstavitev">
                                je leta 2018 internetno povezavo imelo vsaj 40% prebivalstva sveta?
                            </b>
                        </p>
                        <p class="postavitev-besedila-spletna-predstavitev navadno-besedilo">
                            Leta 1995 nas je bilo manj kot 1%.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'VsebinaZacetnaStran'
  }
</script>
<style scoped src="../../../../../../static/css/Nastavitve/SpletnaPredstavitev/VsebinaZacetnaStran.css">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/SpletnaPredstavitev/VsebinaZacetnaStran.vue